import React from 'react';
import { cards } from '@/mock-data/cards';
import { CardsList } from '@/components/Profile/Cards/CardsList';
import { CardsEmpty } from '@/components/Profile/Cards/CardsEmpty';
import { TechIssues } from '@/components/Profile/Cards/TechIssues';

// TODO: this is mock
const isTechIssues = false;

export const PaymentMethodsSection = () => {
  return (
    <>
      {isTechIssues ? (
        <TechIssues />
      ) : cards.length ? (
        <CardsList cards={cards} />
      ) : (
        <CardsEmpty />
      )}
    </>
  );
};
